import _implicitStylesheets from "./button.css";
import _implicitScopedStylesheets from "./button.scoped.css?scoped=true";
import {freezeTemplate, registerTemplate} from "lwc";
const stc0 = {
  attrs: {
    "name": "start"
  },
  key: 1
};
const stc1 = [];
const stc2 = {
  attrs: {
    "name": "end"
  },
  key: 2
};
const stc3 = {
  attrs: {
    "name": "start"
  },
  key: 4
};
const stc4 = {
  attrs: {
    "name": "end"
  },
  key: 5
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, s: api_slot, d: api_dynamic_text, t: api_text, h: api_element} = $api;
  return [!$cmp.isAnchor ? api_element("button", {
    className: api_normalize_class_name($cmp.classes),
    attrs: {
      "aria-disabled": $cmp.disabled,
      "aria-label": $cmp.ariaLabel,
      "aria-live": $cmp.ariaLive,
      "type": $cmp.type,
      "form": $cmp.form,
      "disabled": $cmp.disabled ? "" : null
    },
    key: 0
  }, [api_slot("start", stc0, stc1, $slotset), api_text(api_dynamic_text($cmp.text)), api_slot("end", stc2, stc1, $slotset)]) : null, $cmp.isAnchor ? api_element("a", {
    className: api_normalize_class_name($cmp.classes),
    attrs: {
      "href": $cmp.href,
      "target": $cmp.target,
      "aria-disabled": $cmp.disabled,
      "aria-label": $cmp.ariaLabel,
      "aria-live": $cmp.ariaLive,
      "disabled": $cmp.disabled
    },
    key: 3
  }, [api_slot("start", stc3, stc1, $slotset), api_text(api_dynamic_text($cmp.text)), api_slot("end", stc4, stc1, $slotset)]) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.slots = ["end", "start"];
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-nfvqqei982";
tmpl.legacyStylesheetToken = "undefined-_button";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
